// extracted by mini-css-extract-plugin
export default {"video":"DUxKjC","canvasWrapper":"DpzPMw","vimeo":"KK7qkr"};